<template>
  <validation-provider v-slot="{ errors }" :rules="validates" :name="name">
    <div class="phone-input-wrap form-group" :class="{ 'has-errors': errors.length }" :style="{ marginBottom }">
      <label v-if="label" class="form-control-label">{{ label }}</label>
      <vue-tel-input
        v-model="phoneNumber"
        :input-options="{
          name,
          placeholder,
          autocomplete: 'off',
          styleClasses: { 'form-control': true, 'is-invalid': errors.length },
          autofocus: false,
          showDialCode: false,
          tabindex: 0
        }"
        :disabled="disabled"
        :valid-characters-only="true"
        :ignored-countries="['IO','NR','SH','SX','TK','WF']"
        :mode="mode"
        @validate="handleValidate"
        @input="handleInput"
      />
      <b-form-invalid-feedback v-if="errors.length">{{ errors[0] }}</b-form-invalid-feedback>
    </div>
  </validation-provider>
</template>

<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import { VueTelInput } from 'vue-tel-input'
export default {
  components: {
    VueTelInput
  },
  props: {
    value: { type: [String], required: false, default: '' },
    name: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    rules: { type: String, default: '' },
    disabledFetchingCountry: { type: Boolean, default: false },
    marginBottom: { type: String, default: '1rem' },
    mode: { type: String, default: 'international' }
  },
  data() {
    return {
      margin: '',
      phoneNumber: '',
      validates: {
        required: false,
        regex: /^.{1,}$/
      }
    }
  },
  mounted() {
    this.phoneNumber = this.value || ''
    if (this.rules && this.rules.match(/required/)) this.validates.required = true
  },
  methods: {
    handleValidate(args) {
      if (this.rules.match(/phone/)) {
        if (args.valid) {
          this.validates.regex = /^.{6,}$/
          this.$emit('input', args.number || null)
        } else {
          this.validates.regex = /^.{36,}$/
        }
      } else {
        this.$emit('input', args.number || null)
        this.validates.regex = ''
      }
    },
    handleInput(number) {
      this.$emit('input', number)
    }
  }
}
</script>

<style lang="scss">
.phone-input-wrap.form-group {
  &.has-errors {
    .vue-tel-input { border-color: #ff5c75; }
    .invalid-feedback { display: block; }
  }
  .vti__dropdown {
    background: #FFF;
    &:focus, &:active { outline: none !important; }
  }
  .vue-tel-input {
    border: 1px solid #e2e7f1;
    &:focus { border-color: #5369f8; outline: 0; -webkit-box-shadow: none; box-shadow: none; }
    .vti__input {
      border: none !important;
      &.form-control { border: none !important; }
    }
  }
}
</style>